import React from 'react';
import { motion } from 'framer-motion';

const UPWORK_URL = 'https://www.upwork.com/freelancers/~01902b7448e204d256?mp_source=share';

const Contact: React.FC = () => {
  return (
    <section id="contact" className="py-24 bg-gradient-to-br from-blue-50 via-white to-blue-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight pb-1 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600">
            Let's Create Something Amazing Together
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            Have a project in mind? Reach out via Upwork to get started.
          </p>
        </div>

        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg neo-surface">
              <h3 className="text-2xl font-bold mb-4 text-gray-800 dark:text-white">Why Work With Me?</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <span className="text-2xl">🚀</span>
                  <div>
                    <h4 className="font-semibold text-gray-800 dark:text-white">Fast Delivery</h4>
                    <p className="text-gray-600 dark:text-gray-300">Quick turnaround times without compromising quality</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-2xl">💡</span>
                  <div>
                    <h4 className="font-semibold text-gray-800 dark:text-white">Innovative Solutions</h4>
                    <p className="text-gray-600 dark:text-gray-300">Cutting-edge technology and modern approaches</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-2xl">🤝</span>
                  <div>
                    <h4 className="font-semibold text-gray-800 dark:text-white">Dedicated Support</h4>
                    <p className="text-gray-600 dark:text-gray-300">Responsive communication and reliable delivery</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div className="relative">
            <motion.a
              href={UPWORK_URL}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="w-full inline-flex items-center justify-center bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold py-4 px-8 rounded-xl hover:shadow-xl transition-all duration-300 neo-button"
            >
              Contact on Upwork
              <span className="ml-2">↗</span>
            </motion.a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;